import React from 'react';
import Locale from '../locales/en/contact';
import MailchimpSignupForm from './MailchimpSignupForm';
import TitleSVG from '../images/blueprint-title.svg';
import PillarsSVG from '../images/introduction-bg.svg';
import Footer from './Footer';

const FullPageContact = () => (
  <div id="full-page-contact">
    <a href="/" className="header">
      <img src={TitleSVG} alt="Center for New York City Neighborhoods logo" />
    </a>
    <div className="content">
      <div className="signup">
        <h3>{Locale.signUp}</h3>
        <p className="subheader">{Locale.signUpText}</p>
        <MailchimpSignupForm />
      </div>
      <div className="contact">
        <div>
          <h3>{Locale.contact}</h3>
          <div
            className="subheader"
            dangerouslySetInnerHTML={{ __html: Locale.sendEmail }}
          />
        </div>
        <div className="to-home">
          <a href="/">
            <img src={PillarsSVG} alt="Back to Equitable Homeownership Blueprint site" />
            <div className="to-home-text">
              <span className="arrow">&larr;&nbsp;&nbsp;</span>
              {Locale.back}
            </div>
          </a>
        </div>
      </div>
    </div>
    <Footer />
  </div>
);

export default FullPageContact;
